/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PaginationDto } from '../models/pagination-dto';
import { reservationControllerCancelByUser } from '../fn/reservation/reservation-controller-cancel-by-user';
import { ReservationControllerCancelByUser$Params } from '../fn/reservation/reservation-controller-cancel-by-user';
import { reservationControllerCreate } from '../fn/reservation/reservation-controller-create';
import { ReservationControllerCreate$Params } from '../fn/reservation/reservation-controller-create';
import { reservationControllerDelete } from '../fn/reservation/reservation-controller-delete';
import { ReservationControllerDelete$Params } from '../fn/reservation/reservation-controller-delete';
import { reservationControllerFindAll } from '../fn/reservation/reservation-controller-find-all';
import { ReservationControllerFindAll$Params } from '../fn/reservation/reservation-controller-find-all';
import { reservationControllerFindById } from '../fn/reservation/reservation-controller-find-by-id';
import { ReservationControllerFindById$Params } from '../fn/reservation/reservation-controller-find-by-id';
import { reservationControllerSearch } from '../fn/reservation/reservation-controller-search';
import { ReservationControllerSearch$Params } from '../fn/reservation/reservation-controller-search';
import { reservationControllerSearchByStatus } from '../fn/reservation/reservation-controller-search-by-status';
import { ReservationControllerSearchByStatus$Params } from '../fn/reservation/reservation-controller-search-by-status';
import { reservationControllerUpdateByAdmin } from '../fn/reservation/reservation-controller-update-by-admin';
import { ReservationControllerUpdateByAdmin$Params } from '../fn/reservation/reservation-controller-update-by-admin';
import { reservationControllerUpdateByUser } from '../fn/reservation/reservation-controller-update-by-user';
import { ReservationControllerUpdateByUser$Params } from '../fn/reservation/reservation-controller-update-by-user';
import { ReservationDto } from '../models/reservation-dto';

@Injectable({ providedIn: 'root' })
export class ReservationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reservationControllerSearch()` */
  static readonly ReservationControllerSearchPath = '/api/v1/reservation/search';

  /**
   * Reservation 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationControllerSearch$Response(params: ReservationControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginationDto>> {
    return reservationControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * Reservation 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationControllerSearch(params: ReservationControllerSearch$Params, context?: HttpContext): Observable<PaginationDto> {
    return this.reservationControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginationDto>): PaginationDto => r.body)
    );
  }

  /** Path part for operation `reservationControllerSearchByStatus()` */
  static readonly ReservationControllerSearchByStatusPath = '/api/v1/reservation/search-my-reservation';

  /**
   * 나의 예약 목록 검색 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationControllerSearchByStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationControllerSearchByStatus$Response(params: ReservationControllerSearchByStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginationDto>> {
    return reservationControllerSearchByStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * 나의 예약 목록 검색 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationControllerSearchByStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationControllerSearchByStatus(params: ReservationControllerSearchByStatus$Params, context?: HttpContext): Observable<PaginationDto> {
    return this.reservationControllerSearchByStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginationDto>): PaginationDto => r.body)
    );
  }

  /** Path part for operation `reservationControllerFindAll()` */
  static readonly ReservationControllerFindAllPath = '/api/v1/reservation';

  /**
   * 모든 Reservation 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationControllerFindAll$Response(params?: ReservationControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReservationDto>>> {
    return reservationControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 Reservation 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationControllerFindAll(params?: ReservationControllerFindAll$Params, context?: HttpContext): Observable<Array<ReservationDto>> {
    return this.reservationControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReservationDto>>): Array<ReservationDto> => r.body)
    );
  }

  /** Path part for operation `reservationControllerCreate()` */
  static readonly ReservationControllerCreatePath = '/api/v1/reservation';

  /**
   * Reservation 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationControllerCreate$Response(params: ReservationControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ReservationDto>> {
    return reservationControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Reservation 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationControllerCreate(params: ReservationControllerCreate$Params, context?: HttpContext): Observable<ReservationDto> {
    return this.reservationControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReservationDto>): ReservationDto => r.body)
    );
  }

  /** Path part for operation `reservationControllerFindById()` */
  static readonly ReservationControllerFindByIdPath = '/api/v1/reservation/{id}';

  /**
   * Reservation id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationControllerFindById$Response(params: ReservationControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ReservationDto>> {
    return reservationControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * Reservation id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationControllerFindById(params: ReservationControllerFindById$Params, context?: HttpContext): Observable<ReservationDto> {
    return this.reservationControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReservationDto>): ReservationDto => r.body)
    );
  }

  /** Path part for operation `reservationControllerDelete()` */
  static readonly ReservationControllerDeletePath = '/api/v1/reservation/{id}';

  /**
   * Reservation 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationControllerDelete$Response(params: ReservationControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return reservationControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Reservation 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationControllerDelete(params: ReservationControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.reservationControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reservationControllerUpdateByUser()` */
  static readonly ReservationControllerUpdateByUserPath = '/api/v1/reservation/{id}';

  /**
   * 회원 예약 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationControllerUpdateByUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationControllerUpdateByUser$Response(params: ReservationControllerUpdateByUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ReservationDto>> {
    return reservationControllerUpdateByUser(this.http, this.rootUrl, params, context);
  }

  /**
   * 회원 예약 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationControllerUpdateByUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationControllerUpdateByUser(params: ReservationControllerUpdateByUser$Params, context?: HttpContext): Observable<ReservationDto> {
    return this.reservationControllerUpdateByUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReservationDto>): ReservationDto => r.body)
    );
  }

  /** Path part for operation `reservationControllerCancelByUser()` */
  static readonly ReservationControllerCancelByUserPath = '/api/v1/reservation/{id}/cancel-by-user';

  /**
   * [회원] 예약 취소.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationControllerCancelByUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationControllerCancelByUser$Response(params: ReservationControllerCancelByUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ReservationDto>> {
    return reservationControllerCancelByUser(this.http, this.rootUrl, params, context);
  }

  /**
   * [회원] 예약 취소.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationControllerCancelByUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationControllerCancelByUser(params: ReservationControllerCancelByUser$Params, context?: HttpContext): Observable<ReservationDto> {
    return this.reservationControllerCancelByUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReservationDto>): ReservationDto => r.body)
    );
  }

  /** Path part for operation `reservationControllerUpdateByAdmin()` */
  static readonly ReservationControllerUpdateByAdminPath = '/api/v1/reservation/{id}/by-admin';

  /**
   * 관리자 예약 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationControllerUpdateByAdmin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationControllerUpdateByAdmin$Response(params: ReservationControllerUpdateByAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<ReservationDto>> {
    return reservationControllerUpdateByAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 예약 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationControllerUpdateByAdmin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationControllerUpdateByAdmin(params: ReservationControllerUpdateByAdmin$Params, context?: HttpContext): Observable<ReservationDto> {
    return this.reservationControllerUpdateByAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReservationDto>): ReservationDto => r.body)
    );
  }

}
